import React from "react";

const noop = () => {};

const SimpleFileInput = ({ labelText, onChange = noop, ...rest }) => (
      <label className="btn btn-link edit-button accent-link">
         {labelText}
         <input
            {...rest}
            style={{display: "none"}}
            type="file"
            onChange={e => {
               onChange([...e.target.files]);
            }}
         />
      </label>
   )

export const ButtonFileInput = ({ labelText, onChange = noop, ...rest, id = 'hidden_input' }) => {

   return (
      <button type="button"
              className="btn btn-default"
               onClick={() => document.getElementById(id).click() }>

         {labelText}

         <input
            id={id}
            {...rest}
            style={{display: "none"}}
            type="file"
            onChange={e => {
               onChange([...e.target.files], id);
            }}
            onClick={e => {e.target.value = ''} }
         />
      </button>
      )
}

export default SimpleFileInput;


// WEBPACK FOOTER //
// ./src/components/image/SimpleFileInput.js